module.exports = __webpack_public_path__ + "static/media/social-steam.1f7ac638.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-steam.svg
// module id = 281
// module chunks = 0